import serviceAnnouncementPlayer from './service-announcement-player';
export default serviceAnnouncementPlayer;
